import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { startCase, truncate } from 'lodash';
import React from 'react';
import { IBookingReceipt } from '../../../data/entities/event/booking';
import { currencySymbolForCurrencyString } from '../../helpers/currency_helpers';
import { DateFormats, getFullDateLocalTimeZone } from '../date-picker/helpers';
import { Td, Tr } from '../table';
import { displayPaymentMethod, IPendingBookingReceipt } from './helpers';

interface IDeletableRow extends React.PropsWithChildren {
	receipt: IPendingBookingReceipt;
	copyReceipt: (receipt: IBookingReceipt) => any;
	deleteReceipt: (receipt: IBookingReceipt, del: boolean) => any;
}

export const DeletableRow: React.FC<IDeletableRow> = (props) => {
	const rowClasses = [
		...(props.receipt.pending ? ['booking-payment__form-row--pending'] : ['']),
		...(props.receipt.deleted ? ['booking-payment__form-row--deleted'] : [''])
	];

	return <Tr className={rowClasses.join(' ')}>
		<Td className="booking-payment__cell">{getFullDateLocalTimeZone(props.receipt.date, DateFormats.DayMonthYear)}</Td>
		<Td className="booking-payment__cell">{currencySymbolForCurrencyString(props.receipt.currency) + props.receipt.amount.toFixed(2)}</Td>
		{props.children}
		<Td className="booking-payment__cell">{props.receipt.reference && truncate(props.receipt.reference, { length: 20 })}</Td>
		<Td className="booking-payment__cell">{startCase(displayPaymentMethod(props.receipt.method))}</Td>
		<Td className="booking-payment__action-cell">
			<Button onClick={(e) => props.copyReceipt(props.receipt)}>Copy</Button>
			{!props.receipt.deleted ?
				<Button
					bgColor={theme.colours.neutral.darker}
					color={theme.colours.text.lightest}
					hoverColor={theme.colours.neutral.dark}
					onClick={(e) => props.deleteReceipt(props.receipt, true)}>Delete</Button>
				:
				<Button onClick={(e) => props.deleteReceipt(props.receipt, false)}>Undo</Button>
			}
		</Td>
	</Tr>;
};
